var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#E89639"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2889 16.4643C15.1769 16.6563 14.9769 16.7603 14.7769 16.7603C14.6729 16.7603 14.5609 16.7283 14.4649 16.6723L12.2809 15.3603C12.0969 15.2563 11.9849 15.0563 11.9849 14.8483V12.0243C11.9849 11.6882 12.2569 11.4242 12.5849 11.4242C12.9129 11.4242 13.1849 11.6882 13.1849 12.0243V14.5043L15.0809 15.6483C15.3689 15.8163 15.4649 16.1843 15.2889 16.4643ZM12.7209 7.92822C9.20091 7.92822 6.33691 10.7922 6.33691 14.3123C6.33691 17.8323 9.20091 20.6963 12.7209 20.6963C16.2409 20.6963 19.1049 17.8323 19.1049 14.3123C19.1049 10.7922 16.2409 7.92822 12.7209 7.92822Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.43735 7.42191C8.71975 7.24751 8.80695 6.87791 8.63255 6.59631C8.45735 6.31391 8.08775 6.22671 7.80695 6.40111C6.70855 7.07871 5.74855 7.99311 5.03095 9.04511C4.84455 9.31871 4.91495 9.69231 5.18855 9.87871C5.29175 9.94991 5.40935 9.98351 5.52615 9.98351C5.71815 9.98351 5.90615 9.89151 6.02215 9.72191C6.64615 8.80751 7.48135 8.01231 8.43735 7.42191Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4225 9.04552C19.6977 7.98152 18.7345 7.06392 17.6377 6.39192C17.3553 6.21912 16.9857 6.30712 16.8121 6.58952C16.6393 6.87272 16.7273 7.24152 17.0097 7.41512C17.9641 7.99912 18.8009 8.79672 19.4313 9.72152C19.5473 9.89192 19.7353 9.98312 19.9273 9.98312C20.0433 9.98312 20.1609 9.94952 20.2649 9.87912C20.5385 9.69272 20.6089 9.31912 20.4225 9.04552Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.0c52f635bb6c5fe0bea72b3ac5f53005.svg";
export { ForwardRef as ReactComponent };